import * as React from 'react';
import EnergyJuniorStaffingIndexChart from './energy-junior-staffing-index-chart';
import EnergyJuniorStaffingIndexHeader from './energy-junior-staffing-index-header';
import "./../../dashboard-energy-banker/energy-banker-time-log/energy-banker-time-log.scss";
import "./energy-junior-staffing-index.scss";
import { DashboardGridSkeletonRectangle } from '../../../dashboard-skeletons/dashboard-skeleton-rectangle';
import PropTypes from 'prop-types';
import { useFluentToast } from '../../../../../components/FluentUI/Fluent-Toast';

const EnergyJuniorStaffingIndex = React.memo(({
    energyJuniorStaffingIndexData,
    fetchEnergyJuniorStaffingIndex,
    setIsEnergyJuniorStaffingIndexLoading,
    isEnergyJuniorStaffingIndexLoading,
}) => {
    const chartRef = React.useRef(null);
    const [expandClass, setExpandClass] = React.useState("");
    const [period, setPeriod] = React.useState(8);
    const { showToast, FluentToast } = useFluentToast("bottom", true);

    const expandWidget = () => {
        setExpandClass(expandClass === "" ? "widgetExpanded" : "");
    };
    const onPeriodChange = (newPeriod) => {
        setIsEnergyJuniorStaffingIndexLoading(true);
        setPeriod(newPeriod);
        fetchEnergyJuniorStaffingIndex(newPeriod)
            .then(() => {
                setIsEnergyJuniorStaffingIndexLoading(false)
            });
    };

    return (
        <div className={`energy-banker-time-log energy-staffing-index ${expandClass} dashboard-container-shadow p-1`}>
            <EnergyJuniorStaffingIndexHeader expandClass={expandClass} expandWidget={expandWidget} onPeriodChange={onPeriodChange} period={period} energyJuniorStaffingIndexData={energyJuniorStaffingIndexData} chartRef={chartRef} showToast={showToast} />
            {isEnergyJuniorStaffingIndexLoading ?
                <DashboardGridSkeletonRectangle width="95vw" />
                :
                energyJuniorStaffingIndexData &&
                <EnergyJuniorStaffingIndexChart chartRef={chartRef} energyJuniorStaffingIndexData={energyJuniorStaffingIndexData} />}
            <div className="position-relative">{FluentToast}</div>
        </div>
    );
});

EnergyJuniorStaffingIndex.propTypes = {
    energyJuniorStaffingIndexData: PropTypes.shape({
        ChartData: PropTypes.shape({
            Dates: PropTypes.array,
            EstimatedIndex: PropTypes.array,
            ReportedIndex: PropTypes.array,
        }),
        ExportData: PropTypes.array,
    }),
    fetchEnergyJuniorStaffingIndex: PropTypes.func,
    setIsEnergyJuniorStaffingIndexLoading: PropTypes.func,
    isEnergyJuniorStaffingIndexLoading: PropTypes.bool,
};

export default EnergyJuniorStaffingIndex;